module.exports = __webpack_public_path__ + "static/media/sort-alpha-down-alt.5bdda2a9.svg";